/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Players_NoneInputs */

const th_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เป็นผู้ปกครองของผู้เล่นใช่ไหม เพิ่มพวกเขาที่นี่เพื่อลงทะเบียนค่ายหรือติดตามทีม`)
};

const en_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardian to a player? Add them here to enter them in a camp or follow their team.`)
};

const ja_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選手の保護者ですか？ここに追加すると、キャンプへの登録やチームのフォローができます。`)
};

const zh_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你是某位球员的监护人吗？在这里添加他，即可为其报名训练营或关注他的球队。`)
};

const es_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eres tutor de algún jugador? Añádelo aquí para inscribirlo en un campus o seguir a su equipo.`)
};

const pt_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É responsável por algum jogador? Adicione aqui para inscrevê-lo numa clínica ou seguir o time dele.`)
};

const id_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjadi wali seorang pemain? Tambahkan di sini untuk mendaftarkannya ke kamp atau mengikuti timnya.`)
};

const fr_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuteur d’un joueur ? Ajoutez-le ici pour l’inscrire à un stage ou suivre son équipe.`)
};

const tl_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagapag-alaga ka ba ng isang manlalaro? Idagdag siya rito para maipasok sa camp o masundan ang team niya.`)
};

const vi_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn là người giám hộ của một cầu thủ? Hãy thêm họ ở đây để đăng ký trại tập hoặc theo dõi đội của họ.`)
};

const ko_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수의 보호자이신가요? 여기에 추가하면 캠프에 등록하거나 소속 팀을 팔로우할 수 있습니다.`)
};

const de_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erziehungsberechtigt für einen Spieler? Füge ihn hier hinzu, um ihn für ein Camp zu melden oder seinem Team zu folgen.`)
};

const ru_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы опекун игрока? Добавьте его сюда, чтобы записать в лагерь или подписаться на его команду.`)
};

const tr_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir oyuncunun velisi misiniz? Kampa kaydetmek ya da takımını takip etmek için onu buraya ekleyin.`)
};

const it_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei tutore di un giocatore? Aggiungilo qui per iscriverlo a un camp o seguire la sua squadra.`)
};

const pl_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesteś opiekunem zawodnika? Dodaj go tutaj, aby zapisać go na obóz albo obserwować jego drużynę.`)
};

const uk_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви опікун гравця? Додайте його сюди, щоб записати в табір або стежити за його командою.`)
};

const hi_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप किसी खिलाड़ी के अभिभावक हैं? उन्हें यहाँ जोड़ें ताकि कैंप में पंजीकरण करा सकें या उनकी टीम फ़ॉलो कर सकें।`)
};

const ar_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل أنت وليّ أمر لاعب؟ أضفه هنا لتسجّله في معسكر أو تتابع فريقه.`)
};

const ms_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda penjaga seorang pemain? Tambahkannya di sini untuk mendaftarkannya ke kem atau mengikuti pasukannya.`)
};

const bn_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি কি কোনও খেলোয়াড়ের অভিভাবক? ক্যাম্পে নিবন্ধন করাতে বা তাঁর দল অনুসরণ করতে এখানে যোগ করুন।`)
};

const zh_tw2_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你是某位球員的監護人嗎？在這裡新增他，即可為他報名訓練營或追蹤他的球隊。`)
};

const zh_hk2_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你是某位球員的監護人嗎？在這裡新增他，即可為他報名訓練營或追蹤他的球隊。`)
};

const ur_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کیا آپ کسی کھلاڑی کے سرپرست ہیں؟ کیمپ میں رجسٹر کرانے یا ان کی ٹیم فالو کرنے کے لیے انہیں یہاں شامل کریں۔`)
};

const fa_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سرپرست بازیکنی هستید؟ او را اینجا بیفزایید تا در اردویی ثبت‌نامش کنید یا تیمش را دنبال کنید.`)
};

const sw_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wewe ni mlezi wa mchezaji? Mwongeze hapa ili kumsajili kwenye kambi au kuifuatilia timu yake.`)
};

const nl_your_players_none = /** @type {(inputs: Your_Players_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ben je voogd van een speler? Voeg hem hier toe om hem voor een kamp in te schrijven of zijn team te volgen.`)
};

/**
* | output |
* | --- |
* | "Guardian to a player? Add them here to enter them in a camp or follow their team." |
*
* @param {Your_Players_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_players_none = /** @type {((inputs?: Your_Players_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Players_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_your_players_none(inputs)
	if (locale === "ja") return ja_your_players_none(inputs)
	if (locale === "zh") return zh_your_players_none(inputs)
	if (locale === "es") return es_your_players_none(inputs)
	if (locale === "pt") return pt_your_players_none(inputs)
	if (locale === "id") return id_your_players_none(inputs)
	if (locale === "fr") return fr_your_players_none(inputs)
	if (locale === "tl") return tl_your_players_none(inputs)
	if (locale === "vi") return vi_your_players_none(inputs)
	if (locale === "ko") return ko_your_players_none(inputs)
	if (locale === "de") return de_your_players_none(inputs)
	if (locale === "ru") return ru_your_players_none(inputs)
	if (locale === "tr") return tr_your_players_none(inputs)
	if (locale === "it") return it_your_players_none(inputs)
	if (locale === "pl") return pl_your_players_none(inputs)
	if (locale === "uk") return uk_your_players_none(inputs)
	if (locale === "hi") return hi_your_players_none(inputs)
	if (locale === "ar") return ar_your_players_none(inputs)
	if (locale === "ms") return ms_your_players_none(inputs)
	if (locale === "bn") return bn_your_players_none(inputs)
	if (locale === "zh-TW") return zh_tw2_your_players_none(inputs)
	if (locale === "zh-HK") return zh_hk2_your_players_none(inputs)
	if (locale === "ur") return ur_your_players_none(inputs)
	if (locale === "fa") return fa_your_players_none(inputs)
	if (locale === "sw") return sw_your_players_none(inputs)
	if (locale === "nl") return nl_your_players_none(inputs)
	return en_your_players_none(inputs)
});